<template>
  <div id="app">
    <keep-alive>
      <router-view ref="routerView" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view ref="routerView" v-if="!$route.meta.keepAlive"></router-view>

  </div>
</template>

<script>
  export default {
    name: "App",
    data() {
      return {
        index: 4,
        flag: false,

        isphone: true,
      };
    },
    created() {},
    watch: {

    },
    mounted() {

    },
    methods: {

    },
  };
</script>

<style lang="less">
  @vm_base: 1/750 * 100vw;
  @import "./common/custom_elementui.less";

  // ::-webkit-scrollbar {
  //   width: 3px;
  //   height: 3px;
  // }

  // ::-webkit-scrollbar-thumb {
  //   background: #FB9427;
  // }

  * {
    padding: 0;
    margin: 0;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    box-sizing: border-box;
  }

  div {
    box-sizing: border-box;
    word-break: break-all;
    line-height: 1;
    font-weight: normal;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    min-height: 100vh;
    height: auto;
    background-color: #F6F7F9;
  }

  .clearboth {
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue